"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof3 = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _typeof2 = _interopRequireDefault(require("@babel/runtime/helpers/typeof"));
var _react = _interopRequireWildcard(require("react"));
var _Share = _interopRequireDefault(require("../../Share"));
var _Image = _interopRequireDefault(require("../../Image"));
var _classnames = _interopRequireDefault(require("classnames"));
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof3(e) && "function" != typeof e) return { "default": e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n["default"] = e, t && t.set(e, n), n; }
var __assign = void 0 && (void 0).__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];
      for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
    }
    return t;
  };
  return __assign.apply(this, arguments);
};
var __rest = void 0 && (void 0).__rest || function (s, e) {
  var t = {};
  for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};
var __spreadArrays = void 0 && (void 0).__spreadArrays || function () {
  for (var s = 0, i = 0, il = arguments.length; i < il; i++) s += arguments[i].length;
  for (var r = Array(s), k = 0, i = 0; i < il; i++) for (var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++) r[k] = a[j];
  return r;
};
var Article = function Article(props) {
  var onCallbackHandle = props.onCallbackHandle,
    href = props.href,
    supplement = props.supplement,
    record = props.record,
    article = props.article,
    title = props.title,
    _a = props.extendsProps,
    extendsProps = _a === void 0 ? {} : _a;
  var source = record.source;
  var refsHeight = (0, _react.useRef)(null);
  var contentRef = (0, _react.useRef)(null);
  var hoverRef = (0, _react.useRef)(null);
  (0, _react.useEffect)(function () {
    if (refsHeight && refsHeight.current && hoverRef.current) {
      if (refsHeight.current.clientHeight >= refsHeight.current.scrollHeight - 9) {
        hoverRef.current.style.visibility = 'hidden';
        // @ts-ignore
        refsHeight.current.style['-webkit-mask-image'] = 'none';
      } else {
        if (contentRef.current) {
          contentRef.current.style.minHeight = 230 + "px";
        }
      }
    }
  }, []);
  console.log(extendsProps, 'extendsProps:::::::::::::');
  return /*#__PURE__*/_react["default"].createElement("a", __assign({
    className: 'flex-default-article',
    href: href
  }, extendsProps), /*#__PURE__*/_react["default"].createElement(_Image["default"], {
    className: 'img-circle-angle-default',
    width: '368',
    height: '207',
    source: source,
    style: {
      height: 'auto',
      backgroundRepeat: 'no-repeat',
      borderTopLeftRadius: '4px',
      borderTopRightRadius: '4px',
      borderBottomLeftRadius: 0,
      borderBottomRightRadius: 0
    }
  }), /*#__PURE__*/_react["default"].createElement("section", {
    ref: contentRef,
    onClick: function onClick() {
      onCallbackHandle && onCallbackHandle(record);
    }
  }, /*#__PURE__*/_react["default"].createElement("strong", null, title), /*#__PURE__*/_react["default"].createElement("div", {
    ref: refsHeight,
    className: 'div-content div-content-hover',
    dangerouslySetInnerHTML: {
      __html: article || ''
    }
  }), !supplement ? ( /*#__PURE__*/_react["default"].createElement("img", {
    ref: hoverRef,
    className: 'div-content-initial-img',
    src: 'https://main.qcloudimg.com/qcintl-cms/154/1621847631362/bbf8fdaf01ca6c05f0ad039a89d3fa21.png'
  })) : null));
};
var FlexScenariosCardShareT = /*#__PURE__*/(0, _react.forwardRef)(function (props, ref) {
  var style = props.style,
    configuration = props.configuration,
    onCallbackHandle = props.onCallbackHandle,
    restProps = __rest(props, ["style", "configuration", "onCallbackHandle"]);
  // supplement arr length
  var compatibleArr = configuration && configuration.length % 3 ? __spreadArrays(configuration, new Array(3 - configuration.length % 3).fill({
    supplement: true
  })) : configuration;
  return /*#__PURE__*/_react["default"].createElement("div", __assign({
    ref: ref
  }, restProps, {
    className: 'flex-default-grid-c-card-container',
    style: (0, _typeof2["default"])(style) === 'object' ? style : {}
  }), /*#__PURE__*/_react["default"].createElement("div", {
    className: 'flex-default-grid-c-card-container-children'
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: 'flex-dynamic-default-grid-card'
  }, compatibleArr && compatibleArr.map(function (item, index) {
    var content = item.content,
      title = item.title,
      href = item.href,
      key = item.key,
      time = item.time,
      shareList = item.shareList,
      supplement = item.supplement,
      _a = item.extendsProps,
      extendsProps = _a === void 0 ? {} : _a;
    return /*#__PURE__*/_react["default"].createElement("div", {
      key: index,
      className: (0, _classnames["default"])('flex-dynamic-cover-default-shared-card', {
        'flex-dynamic-default-shared-card-none': supplement
      })
    }, /*#__PURE__*/_react["default"].createElement("div", null, /*#__PURE__*/_react["default"].createElement("div", {
      style: {
        zIndex: compatibleArr ? compatibleArr.length - index : 0
      },
      className: 'flex-default-text-article'
    }, /*#__PURE__*/_react["default"].createElement("div", {
      className: 'flex-text-article-container',
      key: index
    }, /*#__PURE__*/_react["default"].createElement("div", {
      className: 'grid-img-container'
    }, /*#__PURE__*/_react["default"].createElement("div", {
      className: 'grid-img-container-div'
    }, /*#__PURE__*/_react["default"].createElement(Article, {
      key: key,
      record: item || {},
      onCallbackHandle: onCallbackHandle,
      article: content,
      supplement: supplement,
      title: title,
      href: href,
      extendsProps: extendsProps
    }), /*#__PURE__*/_react["default"].createElement(_Share["default"], {
      time: time,
      shareList: shareList
    })))))));
  }))));
});
FlexScenariosCardShareT.displayName = 'TCIFlexScenariosCardShareT';
var _default = exports["default"] = FlexScenariosCardShareT;